// Interface roles only: Firestore rules still let every organization member write inventories.
// Admin write callables enforce the admin role server side; supervisors can only record
// conversion results through applyAdminInventoryChanges.
export const ADMIN_ROLE = 'admin';
export const SUPERVISOR_ROLE = 'supervisor';

const includesUser = (list, userId) => Array.isArray(list) && list.includes(userId);

// Mirrors the backend assertInventoryAdmin/assertInventoryViewer checks; admin rights take precedence.
export function inventoryRoles({
  userId, appData, memberRole, isSuperAdmin,
}) {
  if (isSuperAdmin || memberRole === 'admin' || includesUser(appData?.admins, userId)) {
    return [ADMIN_ROLE];
  }
  if (includesUser(appData?.supervisors, userId)) {
    return [SUPERVISOR_ROLE];
  }
  return [];
}

export function adminPermissions(roles = []) {
  const canEditAdmin = roles.includes(ADMIN_ROLE);
  const canViewAdmin = canEditAdmin || roles.includes(SUPERVISOR_ROLE);
  return {
    canViewAdmin, canEditAdmin, canCalculate: canViewAdmin, isSupervisor: canViewAdmin && !canEditAdmin,
  };
}
